import React from 'react'
import { hydrateRoot } from 'react-dom/client';
import { App } from './app'
import { BrowserRouter } from "react-router-dom";

document
    .querySelectorAll(
      'html > *:not(body, head), script[src*="extension://"], link[href*="extension://"]',
    )
    .forEach((s:any) => {
      s.parentNode.removeChild(s);
    });



hydrateRoot(document, <BrowserRouter><App xApiKey={window.xApiKey} cachedAPI={window.cachedAPI} sseBaseUrl={window?.app_data?.appcmsMain?.apiConfig?.sseBaseUrl} siteConfig={window.app_data} pageData={window.page_data} browserDetails={window.browserDetails} apiBaseUrl={window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl} analyticsBaseUrl={window.analyticsBaseUrl} wssBaseUrl={window.wssBaseUrl} env={window.env} ip={window.ip} embedCodeToken={window?.embedCodeToken} toolsUrl={window?.toolsUrl} templateUrl={window?.templateUrl} requestId={window?.requestId} cssHref={window.cssHref} scriptSrcs={window.scriptSrcs} isPreview={window.isPreview}/></BrowserRouter>)
